<template>
  <div class="record" @click="navigateToDetail">
    <div class="header">
      <div class="icon"></div>
      <div class="label">{{ detail.title }}</div>
      <div class="time">{{ detail.applyTime }}</div>
    </div>
    <div class="body">
      <div class="title">
        <div class="text">
          {{ detail.approveMsg && detail.approveMsg.title }}
        </div>
        <div class="tag">{{ detail.statusName }}</div>
      </div>
      <!-- <div class="info">
        时长：{{ detail.approveMsg && detail.approveMsg.leaveHours }}
      </div>
      <div class="info">
        开始时间：{{ detail.approveMsg && detail.approveMsg.startTime }}
      </div>
      <div class="info">
        结束时间：{{ detail.approveMsg && detail.approveMsg.endTime }}
      </div> -->
      <div
        class="info"
        style="white-space: pre"
        v-html="detail.approveMsg && detail.approveMsg.content"
      ></div>
      <div class="status">{{ detail.approvalDescription }}</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "TodoItem",
  props: {
    RUserId: {
      type: [String, Array]
    },
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    navigateToDetail() {
      let { bizType, detailId } = this.detail;
      console.log("ddddd========", this.detail);
      if (!detailId) {
        Toast.fail(`${bizType}缺少detailId！`);
        return;
      }
      if (bizType === "teacher_leave") {
        let appUrl = `/pages/teacherAskForLeave/pages/leave/teacherLeaveDetail?leaveApplyId=${detailId}&type=2`;
        let moduleName = "老师请假";
        // let { moduleName, appUrl } = item;
        if (appUrl) {
          /* eslint-disable */
          uni.navigateTo({
            url: appUrl.indexOf("/") !== 0 ? `/${appUrl}` : appUrl
          });
					dd.navigateTo({url: '/' + appUrl })
          /* eslint-disable */
        } else {
          Toast.fail(`${moduleName}缺少跳转地址，请联系管理员添加！`);
        }
      }
      if (bizType === "teacher_attendance") {
        let appUrl = `/pages/teacherAttendance/pages/re-check-approval?id=${detailId}&type=2`;
        let moduleName = "老师补卡";
        // let { moduleName, appUrl } = item;
        if (appUrl) {
          /* eslint-disable */
          uni.navigateTo({
            url: appUrl.indexOf("/") !== 0 ? `/${appUrl}` : appUrl
          });
					dd.navigateTo({url: '/' + appUrl })
          /* eslint-disable */
        } else {
          Toast.fail(`${moduleName}缺少跳转地址，请联系管理员添加！`);
        }
      }

      if (bizType == "student_leave") {
        // pages/web-view/push-message
        // if (!this.RUserId) {
        //   Toast.fail(`${bizType}缺少RUserId！`);
        //   return;
        // }
        /* eslint-disable */
        uni.navigateTo({
          // url: `/pages/web-view/push-message?moduleName=teacher_leave&pushCode=student_leave_apply&id=${detailId}`,
          url: `/pages/web-view/push-message?RUserId=${this.RUserId}&moduleName=student_leave&pushCode=student_leave_apply&id=${detailId}`
        });
				dd.navigateTo({url: `/pages/web-view/push-message?RUserId=${this.RUserId}&moduleName=student_leave&pushCode=student_leave_apply&id=${detailId}` })
        /* eslint-disable */
      }
      if (bizType == "repair") {
        // pages/web-view/push-message
        // if (!this.RUserId) {
        //   Toast.fail(`${bizType}缺少RUserId！`);
        //   return;
        // }
        /* eslint-disable */
        uni.navigateTo({
          url: `/pages/web-view/push-message?RUserId=${this.RUserId}&moduleName=repair&pushCode=repair_approve&id=${detailId}`
        });
				dd.navigateTo({url: `/pages/web-view/push-message?RUserId=${this.RUserId}&moduleName=repair&pushCode=repair_approve&id=${detailId}` })
        /* eslint-disable */
      }
      // else {
      //   Toast.fail(`${bizType}缺少跳转地址，请联系管理员添加！`);
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.record {
  padding: 12px 0;
  border-radius: 8px;
  background-color: #fff;
  margin: 10px 15px;
  .header {
    display: flex;
    height: 44px;
    align-items: center;
    color: #999;
    font-weight: 400;
    font-size: 13px;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 12px;
    .icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 8px;
    }
    .label {
      flex: 1;
    }
  }
  .body {
    color: #666666;
    font-size: 15px;
    font-weight: 400;
    padding: 0 12px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      .text {
        color: #333;
        font-size: 17px;
        font-weight: 600;
      }
      .tag {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 55px;
        height: 20px;
        color: #4275fd;
        font-size: 13px;
        font-weight: 400;
        border-radius: 20px 0 0 20px;
        background: #4275fd33;
        margin-right: -12px;
      }
    }
    .info {
      color: #666666;
    }
    .status {
      color: #ff8948ff;
      margin-top: 12px;
    }
  }
}
</style>
